<template>
	<div class="content min-vh-100 flex-column d-flex justify-content-between">
		<section>
			<h2 class="title pink">
				Insurance Highlights
			</h2>
			<hr />
			<p>
				<b>
					These Insurance Highlights are a summary of the insurance conditions, they are not comprehensive and they do not alter the full Terms and Conditions of the policy visible <download what="terms_and_conditions"/>
				</b>
			</p>
			<div class="flex-grid">
				<div class="item">
					<div class="card">
						<router-link :to="{name: 'TravelAssistance'}">
							<div class="card-body">
								<img src="img/ico-mins-travel-assistance.svg" /> Travel assistance
							</div>
						</router-link>
					</div>
				</div>
				<div class="item">
					<div class="card">
						<router-link :to="{name: 'MedicalExpenses'}">
							<div class="card-body">
								<img src="img/ico-mins-medical.svg" /> Medical expenses
							</div>
						</router-link>
					</div>
				</div>
				<div class="item">
					<div class="card">
						<router-link :to="{name: 'PersonalAccident'}">
							<div class="card-body">
								<img src="img/ico-mins-personal-accident.svg" /> Personal accident
							</div>
						</router-link>
					</div>
				</div>
				<div class="item">
					<div class="card">
						<router-link :to="{name: 'ThirdPartyLiability'}">
							<div class="card-body">
								<img src="img/ico-mins-third-party-liability.svg" /> Third party liability
							</div>
						</router-link>
					</div>
				</div>
				<div class="item">
					<div class="card">
						<router-link :to="{name: 'TravelInconveniences'}">
							<div class="card-body">
								<img src="img/ico-mins-travel-cancellation.svg" /> Travel Inconveniences
							</div>
						</router-link>
					</div>
				</div>
				<div class="item">
					<div class="card">
						<router-link :to="{name: 'CoverStay'}">
							<div class="card-body">
								<img src="img/ico-cover-stay.svg" /> Cover Stay
							</div>
						</router-link>
					</div>
				</div>										
			</div>
		</section>
		<NeedHelp/>
	</div>
</template>

<script>
import NeedHelp from '@/components/NeedHelp.vue'

export default {
	components: {
		NeedHelp
	}
}
</script>
